export default {
  'CHANGE_NEIGHBORHOODS' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_NEIGHBORHOODS' (state) {
    state.items = []
  },
  'SAVE_NEIGHBORHOOD' (state, payload) {
    window.localStorage.setItem('neighborhood', JSON.stringify(payload))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/neighborhoods/mutations.js